import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { ITheme } from '@inter-ikea-kompis/types/lib';
import React, { FunctionComponent, useMemo } from 'react';
import { useAppSelector } from 'redux-store/hooks';
import { selectAppSettings, selectTranslations } from 'redux-store/rootReducer';
import { IAppSettings } from 'redux-store/settings/settings.store';
import ISkyttaTranslations from 'redux-store/translations/ISkyttaTranslations';
import { getTheme } from 'utils/getTheme';

interface IContextProps {
  theme: ITheme;
  settings: IAppSettings;
  translations: ISkyttaTranslations;
  useMetric: boolean;
}

const theme = getTheme(SkapaTheme);
const KompisContext = React.createContext({} as IContextProps);

export const useKompis = () => {
  return React.useContext(KompisContext);
};

export const KompisProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  const settings = useAppSelector(selectAppSettings);
  const translations = useAppSelector(selectTranslations);

  const memoValues = useMemo(() => {
    if (!settings || !translations) {
      return null;
    }

    const useMetric = settings.localisation.useMetricMeasures;

    return {
      theme,
      settings,
      translations,
      useMetric
    };
  }, [theme, settings, translations]);

  if (!memoValues) {
    return null;
  }

  return <KompisContext.Provider value={memoValues}>{children}</KompisContext.Provider>;
};
